import { createSlice } from '@reduxjs/toolkit';
import { ApplicationStatusMessagesListStateType } from 'src/types/applicationStatusMessagesList';

const initialState: ApplicationStatusMessagesListStateType = {
    data: null,
    dataActive: null,
    loading: false,
    error: false,
};
export const applicationStatusMessagesListSlice = createSlice({
    name: 'applicationStatusMessagesList',
    initialState,
    reducers: {
        getApplicationStatusMessagesActiveListFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getApplicationStatusMessagesActiveListFetchSuccess: (state, action) => {
            state.dataActive = action.payload;
            state.loading = false;
        },
        getApplicationStatusMessagesActiveListFetchFailure: (state, action) => {
            state.dataActive = null;
            state.loading = false;
            state.error = true;
        },
        getApplicationStatusMessagesListFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getApplicationStatusMessagesListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getApplicationStatusMessagesListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateApplicationStatusMessageFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateApplicationStatusMessageFetchSuccess: (state, action) => {
            state.loading = false;
        },
        updateApplicationStatusMessageFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getApplicationStatusMessagesActiveListFetch,
    getApplicationStatusMessagesActiveListFetchSuccess,
    getApplicationStatusMessagesActiveListFetchFailure,
    getApplicationStatusMessagesListFetch,
    getApplicationStatusMessagesListFetchSuccess,
    getApplicationStatusMessagesListFetchFailure,
    updateApplicationStatusMessageFetch,
    updateApplicationStatusMessageFetchSuccess,
    updateApplicationStatusMessageFetchFailure,
} = applicationStatusMessagesListSlice.actions;

export default applicationStatusMessagesListSlice.reducer;
